import React from 'react';



/*
 * TwoColumnInfoTable
 */
const TwoColumnInfoTable = ({
  className,
  rows = [],
}) => {
  return (
    <table className={className}>
      <tbody>
        {
          rows.map((row, rowIdx) => (
            <tr key={rowIdx} className="v-top">
              <td className="lh-copy w4 b">
                {row[0]}
              </td>
              <td className="lh-copy ph4 mw6">
                {row[1]}
              </td>
            </tr>
          ))
        }
      </tbody>
    </table>
  );
};


export {
  TwoColumnInfoTable,
};



// WEBPACK FOOTER //
// ./src/components/elems/Table.js